import { ApplicationAddStipulation } from './add-application.data';

export type ApplicationStipulationOptions = {
  bankStatementsRequired: boolean;
  decisionLogic: boolean;
  creditReportRequired: boolean;
  creditReport: boolean;
  bankStatementStipulation?: ApplicationAddStipulation | null;
  creditReportStipulation?: ApplicationAddStipulation | null;
};

/**
 * Extract required stipulations from the list excluding Bank Statement and Credit Report
 */
export const applicationRequiredStipulations = (stipulations: ApplicationAddStipulation[]) =>
  stipulations
    .filter(
      stipulation => stipulation.required === true && stipulation.displayOnNewApplication === true
    )
    .filter(
      stipulation => stipulation.name !== 'Bank Statement' && stipulation.name !== 'Credit Report'
    );

/**
 * Process the list of stipulations and return configuration options
 */
export const applicationStipulationConfiguration = (
  stipulations: ApplicationAddStipulation[]
): ApplicationStipulationOptions => {
  const config: ApplicationStipulationOptions = {
    bankStatementsRequired: false,
    decisionLogic: false,
    creditReportRequired: false,
    creditReport: false,
    bankStatementStipulation: null,
    creditReportStipulation: null,
  };

  // Check if bank statements are required
  if (
    stipulations.some(
      stip =>
        stip.required === true &&
        stip.displayOnNewApplication === true &&
        stip.name === 'Bank Statement'
    )
  ) {
    config.bankStatementsRequired = true;
  } else {
    config.decisionLogic = true;
  }

  // Check if credit report is required
  if (
    stipulations.some(
      stip =>
        stip.required === true &&
        stip.displayOnNewApplication === true &&
        stip.name === 'Credit Report'
    )
  ) {
    config.creditReportRequired = true;
  } else {
    config.creditReport = true;
  }

  // Find bank statement stipulation
  const bankStatementStipulation = stipulations.find(stip => stip.name === 'Bank Statement');
  if (bankStatementStipulation) {
    config.bankStatementStipulation = bankStatementStipulation;
  }

  // Find credit report stipulation
  const creditReportStipulation = stipulations.find(stip => stip.name === 'Credit Report');
  if (creditReportStipulation) {
    config.creditReportStipulation = creditReportStipulation;
  }

  return config;
};
